import { Modal, StyleSheet, Text, TouchableOpacity, View } from 'react-native'
import { ThemedText, ThemedView } from '@app/theme'
import LogOutUser from '@app/helper/logout'

const LogoutConfirmationModal = ({ modalVisible, toggleModal }: { modalVisible: boolean, toggleModal: () => void }) => {
    return (
        <Modal
            animationType={'fade'}
            transparent={true}
            visible={modalVisible}
            onRequestClose={() => { }}>
            <View
                style={{
                    flex: 1,
                    justifyContent: 'center',
                    alignItems: 'center',
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#1D293966',
                }}>
                <ThemedView
                   bg='bg-surface-page'
                   width={'70%'}
                   maxWidth={508}
                   height={'20%'}
                   justifyContent='center'
                   alignItems='center'
                   borderRadius='sm'
                   borderWidth={2}
                   padding='sm'>
                    <ThemedText color='text-secondary' fontWeight='400' variant='h6s' mb='md'>Are you sure you want to logout?</ThemedText>
                    <View
                        style={{
                            flexDirection: 'row',
                            justifyContent: 'space-evenly',
                            width: '100%',
                            height: 35,
                            alignItems: 'center',
                        }}>
                        <View
                            style={{
                                flexDirection: 'row',
                                justifyContent: 'space-evenly',
                                width: '100%',
                            }}>
                            <View
                                style={{
                                    width: 40,
                                    height: 35,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                <TouchableOpacity onPress={() => {
                                    LogOutUser();
                                    toggleModal()
                                }}>
                                    <ThemedText variant='b3r' color='text-action-primary'>Yes</ThemedText>
                                </TouchableOpacity>
                            </View>
                            <View
                                style={{
                                    width: 40,
                                    height: 35,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}>
                                <TouchableOpacity onPress={() => toggleModal()}>
                                    <ThemedText variant='b3r' color='text-action-primary'>No</ThemedText>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </View>
                </ThemedView>
            </View>
        </Modal>
    )
}

export default LogoutConfirmationModal

const styles = StyleSheet.create({})


